import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, FieldLabel, FieldSwitch, FormField, FormGrid, ModalBody, ModalFoot, ModalHead, Text, } from '@dixa/lib-shared-habla';
import { useCallback, useState } from 'react';
import { v4 as uuid } from 'uuid';
import { FlowNodeTypes } from 'components/powerFlowShared/components/types';
import { getConfirmButtonVerb } from 'components/powerFlowShared/helpers/getConfirmButtonVerb';
import { useIsChanged } from 'components/powerFlowShared/hooks/useIsChanged';
import { AnnouncementPicker } from 'components/shared/announcementPicker';
import { AdapterTypes } from 'components/shared/announcementPicker/adapters';
import styles from './audioMessage.module.scss';
const ANNOUNCEMENT_FIELD = 'announcement';
export function AudioMessage({ node, nodeLabel, triggerClose, replaceNode, }) {
    const { payload } = node;
    const { announcement: { file: savedAnnouncement = null } = {}, hangUpAfterAnnouncement: savedIsChecked, } = payload || {};
    const [isHangChecked, setIsHangChecked] = useState(savedIsChecked);
    const [announcement, setAnnouncement] = useState(savedAnnouncement);
    const [errors, setErrors] = useState({});
    const isChanged = useIsChanged([savedIsChecked, isHangChecked], [savedAnnouncement, announcement]);
    const validate = useCallback(() => {
        const errors = {};
        if (!announcement) {
            errors[ANNOUNCEMENT_FIELD] = 'Please select an announcement file';
        }
        setErrors(errors);
        return Object.keys(errors).length === 0;
    }, [announcement, setErrors]);
    const handleSave = useCallback(() => {
        const isValid = validate();
        if (!isValid) {
            return;
        }
        const { payload: existingNodePayload } = node;
        const payload = Object.assign(Object.assign({}, node), { icon: 'i-announcement', isAction: false, isEditable: true, isRemovable: true, nodeType: FlowNodeTypes.AUDIO_MESSAGE, overlay: [], payload: Object.assign({ announcement: {
                    file: announcement !== null && announcement !== void 0 ? announcement : null,
                } }, (isHangChecked
                ? {
                    hangUpAfterAnnouncement: true,
                    afterAnnouncementNodeId: null,
                }
                : {
                    hangUpAfterAnnouncement: false,
                    afterAnnouncementNodeId: (existingNodePayload === null || existingNodePayload === void 0 ? void 0 : existingNodePayload.afterAnnouncementNodeId) || uuid(),
                })), text: 'Announcement' });
        replaceNode(payload);
        triggerClose();
    }, [isHangChecked, announcement, node, validate, triggerClose, replaceNode]);
    const onAnnouncementSelect = useCallback((item) => {
        setAnnouncement(item);
    }, [setAnnouncement]);
    const onHangChange = useCallback((event) => {
        const { target: { checked: isChecked }, } = event;
        setIsHangChecked(isChecked);
    }, [setIsHangChecked]);
    const announcementError = errors[ANNOUNCEMENT_FIELD];
    return (_jsxs(Box, Object.assign({ width: "600px" }, { children: [_jsx(ModalHead, { title: nodeLabel, onClose: triggerClose }), _jsxs(ModalBody, { children: [_jsx(Text.Paragraph, Object.assign({ subdued: true }, { children: "Record or upload an audio message that\u2019ll play when your customers call you (e.g. informing them when you\u2019re closed for the holidays, that the phone call is going to be recorded, etc.)." })), _jsxs(FormGrid, Object.assign({ className: styles.form }, { children: [_jsx(FormField, { children: _jsx(AnnouncementPicker, { adapter: AdapterTypes.Announcement, selectedAudio: announcement, onSelect: onAnnouncementSelect, fieldProps: { meta: { error: announcementError } } }) }), _jsxs(FormField, { children: [_jsx(FieldLabel, Object.assign({ className: styles.label }, { children: "After audio message" })), _jsxs("div", Object.assign({ className: styles.optionWithSwitch }, { children: [_jsx("span", { children: "Hang up after audio message" }), _jsx(FieldSwitch, { input: {
                                                    name: 'announcement-switch',
                                                    value: 'announcement-switch',
                                                    onChange: onHangChange,
                                                    checked: isHangChecked,
                                                } })] }))] })] }))] }), _jsx(ModalFoot, { confirmOnClick: handleSave, confirmName: getConfirmButtonVerb(node), confirmProps: { disabled: !isChanged }, cancelOnClick: triggerClose })] })));
}
